import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Tabs from 'js/components/common/Tabs';
import { useTranslations } from 'js/hooks/i18n';
import { prop, pick } from 'ramda';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import * as actions from 'js/components/main/MyAccountSidebar/store/actions';

import style from './SidebarTabs.scss';

export const SidebarTabs = ({ path }) => {
    const dispatch = useDispatch();
    const { isMobile, isTablet } = useDeviceSelector(pick(['isMobile', 'isTablet']));
    const t = useTranslations('playtech.mobile.system.tabs.');
    const classNames = { active: style.activeTab, tab: style.tab };
    const { DTAG_SIDEBAR_PROMOTIONS_PAGE, DTAG_SIDEBAR_MY_BONUSES_PAGE } = useAppSelector(prop('dynamicTags'));

    const mobileOrTablet = isMobile || isTablet;
    const isTabsShown = mobileOrTablet && [DTAG_SIDEBAR_PROMOTIONS_PAGE, DTAG_SIDEBAR_MY_BONUSES_PAGE].includes(path);

    const onClick = useCallback((name) => {
        dispatch(actions.showPortalPage({ pageURL: name, isBackArrowHidden: false }));
    }, [dispatch]);

    const tabs = [
        { name: DTAG_SIDEBAR_PROMOTIONS_PAGE, title: t('promotions'), onClick, classNames },
        { name: DTAG_SIDEBAR_MY_BONUSES_PAGE, title: t('myBonuses'), onClick, classNames }
    ];

    return (
        <>
            {isTabsShown
                && <Tabs activeTab={path} tabs={tabs} className={style.tabs} />}
        </>
    );
};
